import * as React from 'react';

export function Initiate(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      aria-label={props.label}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="navigation-icon-initiate"
      {...props}
    >
      <g clipPath="url(#clip0_8981_5568)">
        <path
          d="M1.93359 2.89844C1.93359 1.79387 2.82902 0.898438 3.93359 0.898438H15.9336C17.0382 0.898438 17.9336 1.79387 17.9336 2.89844V18.8984C17.9336 20.003 17.0382 20.8984 15.9336 20.8984H3.93359C2.82902 20.8984 1.93359 20.003 1.93359 18.8984V2.89844Z"
          fill="url(#paint0_linear_8981_5568)"
        />
        <g filter="url(#filter0_bi_8981_5568)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.2618 7.11609C22.1777 7.81515 22.3363 9.13217 21.6126 10.0287L12.5362 21.271C12.4681 21.3554 12.3903 21.4314 12.3044 21.4975L9.25128 23.846C8.29832 24.5791 6.98121 23.6047 7.40336 22.479C7.42357 22.4251 7.44766 22.3727 7.47542 22.3223L9.37982 18.8626C9.39333 18.8381 9.40887 18.8147 9.42628 18.7928L18.4173 7.47029C19.1107 6.5971 20.3755 6.43961 21.2618 7.11609Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            d="M12.5362 21.271L12.1472 20.9569L21.2235 9.7146C21.7705 9.03711 21.6506 8.04183 20.9585 7.51356C20.2886 7.00234 19.3329 7.12135 18.8089 7.78122L9.81784 19.1037L12.5362 21.271ZM12.5362 21.271L12.1472 20.9569C12.1038 21.0107 12.0542 21.0591 11.9995 21.1012M12.5362 21.271L11.9995 21.1012M11.9995 21.1012L12.3044 21.4975L11.9995 21.1012Z"
            stroke="white"
            strokeOpacity="0.2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_bi_8981_5568"
          x="5.82227"
          y="5.19629"
          width="17.7446"
          height="20.4043"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.75" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_8981_5568"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_8981_5568"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_8981_5568"
          />
        </filter>
        <linearGradient
          id="paint0_linear_8981_5568"
          x1="11.9336"
          y1="-2.10156"
          x2="11.9336"
          y2="20.8984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B671FF" stopOpacity="0" />
          <stop offset="1" stopColor="#B873FF" />
        </linearGradient>
        <clipPath id="clip0_8981_5568">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
